var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-container"},[_c('Header',{attrs:{"page":"index"}}),_c('router-view',{key:_vm.key}),(!_vm.$route.meta.isFoot)?_c('Footer',{attrs:{"page":"index"}}):_vm._e(),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }